(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle_selector"] && !Shopify.designMode) return;
  try {
    // Matches snippets/cart-contents.liquid's formatMoney() exactly - see
  // this file's doc comment for why window.Shopify.currency.active (not
  // shop.money_format) is the market-aware source here.
  function formatMoney(cents) {
    return (Number(cents) / 100 || 0).toLocaleString(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      // 'narrowSymbol' (not the default 'symbol') gives plain "$" instead
      // of a region-disambiguated prefix like "MX$" for MXN - see
      // snippets/cart-contents.liquid's formatMoney() for the same fix.
      currencyDisplay: 'narrowSymbol',
    });
  }

  class BundleSelector extends HTMLElement {
    async connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const connection = this.abortController;
      if (window.Shopify?.designMode) {
        window.TendedEditorBundleSelection ||= new Map();
        this.editorSelectionKey = this.closest('.shopify-block')?.id;
      }
      this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
      this.colorOptionIndex = Number(this.dataset.colorOptionIndex);
      this.colorValues = this.readJSON('colorValues', []);
      this.baseOptions = this.readJSON('baseOptions', []);
      this.variants = [];
      this.packageData = new Map();

      // See this file's doc comment for the full mechanism. Resolved once
      // to just this shopper's market's quantity->cents map (or null if
      // this market/product isn't covered) - recomputeSelectedCard() below
      // only ever needs a single lookup by quantity, not the whole
      // per-market structure.
      const discountedTiersByMarket = this.readJSON('discountedTiers', null);
      this.discountedTiers = discountedTiersByMarket?.markets?.[this.dataset.marketHandle]?.tiers || null;

      document.addEventListener('variant:change', (event) => this.onVariantChange(event.detail), {
        signal: this.abortController.signal,
      });

      // Cards already show their server-rendered price - interactivity
      // (color pickers, click-to-select, the live recomputed price) only
      // wires up once real variant data has loaded, so nothing acts on
      // empty/placeholder data.
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${encodeURIComponent(this.dataset.productHandle)}.js`);
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        this.variants = product.variants.map((variant) => ({
          id: variant.id,
          price_cents: variant.price,
          available: variant.available,
          options: [variant.option1, variant.option2, variant.option3].filter(
            (value) => value !== null && value !== undefined
          ),
        }));
      } catch (error) {
        console.error('bundle-selector: failed to load variant data', error);
      }

      const packageRequests = new Map();
      await Promise.all(this.cards.filter((card) => card.dataset.packageHandle).map(async (card) => {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const handle = card.dataset.packageHandle;
          if (!packageRequests.has(handle)) {
            packageRequests.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}.js`).then((response) => {
              if (!response.ok) throw new Error('Product unavailable');
              return response.json();
            }));
          }
          const data = await packageRequests.get(handle);
          this.packageData.set(card, data);
        } catch (error) {
          console.error('bundle-selector: failed to load package', error);
        }
      }));

      if (!this.isConnected || connection.signal.aborted) return;
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const card = event.target.querySelector('[data-bundle-card]');
          if (this.cards.includes(card)) this.select(card);
        }, { signal: this.abortController.signal });
      }
      this.cards.forEach((card) => {
        const selectButton = card.querySelector('[data-bundle-card-select]');
        if (selectButton) {
          selectButton.addEventListener('click', () => this.select(card));
        }
        if (card.dataset.packageHandle) this.buildPackagePickers(card);
        else this.buildColorPickers(card);
      });

      // Every card's own displayed price - not just the selected one (see
      // recomputeSelectedCard() below, which only ever touches the
      // selected card, since it's also computing the exact color-aware
      // line items needed for add-to-cart). A card's displayed price only
      // depends on its own quantity + the shopper's market, not on
      // selection state, so there's no reason it should ever wait for
      // that specific card to be clicked. Real bug this fixes: before
      // this call existed, every card except whichever one happened to be
      // selected kept showing its server-rendered (plain, undiscounted)
      // placeholder forever - invisible previously because that
      // placeholder and the "correct" price were the same number before
      // discount-aware pricing existed, so nothing looked wrong.
      this.updateAllCardPrices();

      const savedCardId = window.TendedEditorBundleSelection?.get(this.editorSelectionKey);
      const initial =
        this.cards.find((card) => savedCardId && card.closest('.shopify-block')?.id === savedCardId) ||
        this.cards.find((card) => card.querySelector('[data-bundle-card-select]')?.getAttribute('aria-pressed') === 'true') ||
        this.cards[0];
      if (initial) this.select(initial);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    readJSON(key, fallback) {
      try {
        const raw = this.dataset[key];
        return raw ? JSON.parse(raw) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    onVariantChange(detail) {
      const variant = this.variants.find((candidate) => candidate.id === detail.variantId);
      if (variant) {
        this.baseOptions = variant.options;
        // A different base variant (e.g. a size swap elsewhere on the
        // page) can change which variant each card's own default-color
        // sum resolves to, same as it already does for the selected card.
        this.updateAllCardPrices();
        this.recomputeSelectedCard();
      }
    }

    // Sets every card's own displayed price - discounted-tiers lookup
    // first (same preference as recomputeSelectedCard() below), falling
    // back to the plain default-color variant sum for whichever
    // quantity/market isn't covered. Deliberately independent of which
    // card is currently selected - see the call site in
    // connectedCallback() for why that distinction matters.
    updateAllCardPrices() {
      this.cards.forEach((card) => {
        if (card.dataset.packageHandle) {
          this.updatePackagePrice(card);
          return;
        }
        const quantity = Number(card.dataset.quantity) || 1;
        const discountedCents = this.discountedTiers ? this.discountedTiers[String(quantity)] : undefined;

        // The TRUE pre-discount total for this card's quantity - variant
        // price_cents comes from /products/{handle}.js (always safe plain-
        // integer cents, see this file's doc comment), so this plain JS
        // multiplication carries none of Liquid's Money-arithmetic risk.
        // Used both as the plain-sum price fallback AND as save_amount's
        // undiscounted reference below - NOT discountedTiers['1'], which
        // is itself already-discounted and wrongly gave a qty=1 card a
        // save_amount of 0 by construction (see blocks/bundle_card.liquid's
        // doc comment for the full explanation of that bug).
        const variant = this.resolveVariant(null);
        const plainSumCents = variant ? (variant.price_cents || 0) * quantity : 0;

        let displayPriceCents = typeof discountedCents === 'number' ? discountedCents : plainSumCents;

        // settings.show_price_per_unit (data-price-per-unit below) -
        // divides AFTER picking discounted-vs-plain above, so "per unit"
        // still reflects the discount when one applies, same as the
        // total would.
        if (card.dataset.pricePerUnit === 'true' && quantity > 0) {
          displayPriceCents = Math.round(displayPriceCents / quantity);
        }

        const priceEl = card.querySelector('[data-bundle-card-price]');
        if (priceEl) priceEl.textContent = formatMoney(displayPriceCents);

        // Mirrors blocks/bundle_card.liquid's own {save_amount} Liquid
        // calculation exactly (plain pre-discount total minus this
        // quantity's discounted tier) - only overwrites the server-
        // rendered fallback when the discounted tier is actually
        // available, same "never show a broken badge" rule as the Liquid
        // side.
        const saveAmountEl = card.querySelector('[data-badge-save-amount]');
        if (saveAmountEl && typeof discountedCents === 'number') {
          saveAmountEl.textContent = formatMoney(plainSumCents - discountedCents);
        }
      });
    }

    packageQuantity(card) {
      return card.dataset.packageQuantity === '2' ? 2 : 1;
    }

    buildPackagePickers(card) {
      const container = card.querySelector('[data-bundle-card-colors]');
      const data = this.packageData.get(card);
      if (!container || !data) return;
      const variant = data.variants.find((item) => item.available) || data.variants[0];
      container.replaceChildren();
      for (let unit = 0; unit < this.packageQuantity(card); unit += 1) {
        const group = document.createElement('fieldset');
        group.className = 'bundle-card__set';
        if (this.packageQuantity(card) > 1) {
          const legend = document.createElement('legend');
          legend.textContent = card.dataset.setLabel.replace('__number__', String(unit + 1));
          group.append(legend);
        }
        data.options.forEach((option, index) => {
          if (option.values.length <= 1) return;
          const label = document.createElement('label');
          const text = document.createElement('span');
          text.textContent = option.name;
          const select = document.createElement('select');
          select.dataset.packageOption = String(index);
          select.dataset.packageUnit = String(unit);
          option.values.forEach((value) => {
            const node = document.createElement('option');
            node.value = value;
            node.textContent = value;
            node.selected = value === variant?.options[index];
            select.append(node);
          });
          select.addEventListener('change', () => this.recomputeSelectedCard());
          label.append(text, select);
          group.append(label);
        });
        if (group.querySelector('select')) container.append(group);
      }
    }

    packageVariants(card) {
      const data = this.packageData.get(card);
      if (!data) return [];
      return Array.from({ length: this.packageQuantity(card) }, (_, unit) => {
        const options = data.options.map((option) => option.values[0]);
        card.querySelectorAll('[data-package-option]').forEach((select) => {
          if (Number(select.dataset.packageUnit || 0) === unit) {
            options[Number(select.dataset.packageOption)] = select.value;
          }
        });
        return data.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      });
    }

    updatePackagePrice(card) {
      const variants = this.packageVariants(card);
      if (variants.length !== this.packageQuantity(card) || variants.some((variant) => !variant)) {
        const priceEl = card.querySelector('[data-bundle-card-price]');
        if (priceEl) { priceEl.textContent = card.dataset.unavailableLabel; priceEl.hidden = false; }
        const badge = card.querySelector('[data-package-badge]');
        if (badge && badge.querySelector('[data-badge-save-amount], [data-badge-save-percent]')) badge.hidden = true;
        return null;
      }
      let entry;
      try {
        const cache = JSON.parse(card.dataset.packageCache || 'null');
        const age = Date.now() - Date.parse(cache?.updated_at);
        if (age >= -300000 && age <= 7200000) entry = cache?.markets?.[this.dataset.marketHandle];
      } catch (error) { /* Missing cache uses the actual product price. */ }
      const reference = variants.reduce((sum, variant) => sum + variant.price, 0);
      const key = variants.map((variant) => String(variant.id)).sort().join('+');
      const uniform = entry?.variant_independent === true &&
        variants.every((variant) => entry.variant_ids?.includes(String(variant.id)));
      const quote = uniform ? entry.quantity_quotes?.[String(variants.length)] : entry?.selections?.[key];
      const currencyMatches = entry?.currency === window.Shopify?.currency?.active;
      // Uniform pricing is an explicit merchant opt-in, with matching base
      // prices and known variant IDs. Quantity two always has its own quote.
      const cached = currencyMatches && quote?.reference === reference ? quote.total : undefined;
      const discounted = Number.isFinite(cached) && cached >= 0;
      const price = discounted ? cached : reference;
      const priceEl = card.querySelector('[data-bundle-card-price]');
      if (priceEl) { priceEl.textContent = formatMoney(price); priceEl.hidden = false; }
      const badge = card.querySelector('[data-package-badge]');
      const amount = card.querySelector('[data-badge-save-amount]');
      const percent = card.querySelector('[data-badge-save-percent]');
      const savings = Math.max(0, reference - price);
      if (amount) amount.textContent = formatMoney(savings);
      if (percent) percent.textContent = `${(reference > 0 ? savings / reference * 100 : 0).toLocaleString(document.documentElement.lang || 'en', { maximumFractionDigits: 1 })}%`;
      if (badge && (amount || percent)) badge.hidden = !discounted || savings <= 0;
      const items = new Map();
      variants.forEach((variant) => items.set(variant.id, (items.get(variant.id) || 0) + 1));
      return {
        items: Array.from(items, ([id, quantity]) => ({ id, quantity })),
        available: variants.every((variant) => variant.available),
        price,
      };
    }

    buildColorPickers(card) {
      const container = card.querySelector('[data-bundle-card-colors]');
      if (!container) return;

      if (this.colorOptionIndex < 0 || !this.colorValues.length) {
        container.hidden = true;
        return;
      }

      const quantity = Number(card.dataset.quantity) || 1;
      container.innerHTML = '';

      for (let unit = 0; unit < quantity; unit += 1) {
        const select = document.createElement('select');
        select.dataset.unitColor = String(unit);
        select.setAttribute('aria-label', `Unit ${unit + 1} color`);

        const defaultColor = this.findDefaultColorForUnit(unit);

        this.colorValues.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          if (value === defaultColor) option.selected = true;
          select.appendChild(option);
        });

        select.addEventListener('click', (event) => event.stopPropagation());
        select.addEventListener('change', () => this.recomputeSelectedCard());
        container.appendChild(select);
      }
    }

    // Spreads defaults across the available colors (so "Buy 2" doesn't
    // default both units to the same color) while guaranteeing every
    // default actually resolves to a real variant - blindly picking
    // colorValues[unit % length] without checking previously caused a
    // silent $0.00 total whenever that combination didn't exist (e.g. a
    // color that isn't sold in the currently selected size).
    findDefaultColorForUnit(unit) {
      for (let offset = 0; offset < this.colorValues.length; offset += 1) {
        const index = (unit + offset) % this.colorValues.length;
        const candidate = this.colorValues[index];
        if (this.resolveVariant(candidate)) return candidate;
      }
      return this.colorValues[0];
    }

    resolveVariant(colorValue) {
      const options = this.baseOptions.slice();
      if (this.colorOptionIndex >= 0 && colorValue) {
        options[this.colorOptionIndex] = colorValue;
      }
      return this.variants.find(
        (candidate) =>
          candidate.options.length === options.length &&
          candidate.options.every((value, index) => value === options[index])
      );
    }

    select(card) {
      if (window.Shopify?.designMode && this.editorSelectionKey) {
        window.TendedEditorBundleSelection.set(this.editorSelectionKey, card.closest('.shopify-block')?.id);
      }
      this.cards.forEach((c) => {
        const selectButton = c.querySelector('[data-bundle-card-select]');
        if (selectButton) selectButton.setAttribute('aria-pressed', String(c === card));
        const colors = c.querySelector('[data-bundle-card-colors]');
        if (colors) colors.hidden = c !== card || (c.dataset.packageHandle
          ? !colors.querySelector('select')
          : this.colorOptionIndex < 0 || !this.colorValues.length);
      });
      this.recomputeSelectedCard();
    }

    recomputeSelectedCard() {
      const card = this.cards.find(
        (c) => c.querySelector('[data-bundle-card-select]')?.getAttribute('aria-pressed') === 'true'
      );
      if (!card) return;

      if (card.dataset.packageHandle) {
        const selection = this.updatePackagePrice(card);
        document.dispatchEvent(new CustomEvent('bundle:change', {
          detail: {
            items: selection?.items || [],
            totalPriceCents: selection?.price,
            available: Boolean(selection?.available),
          },
        }));
        return;
      }

      const colorSelects = Array.from(card.querySelectorAll('[data-unit-color]'));
      const units = colorSelects.length ? colorSelects.map((select) => select.value) : [null];

      const lineItems = new Map();
      let totalPriceCents = 0;
      let available = true;

      units.forEach((colorValue) => {
        const variant = this.resolveVariant(colorValue);
        if (!variant) {
          available = false;
          return;
        }
        if (!variant.available) available = false;
        totalPriceCents += variant.price_cents || 0;
        lineItems.set(variant.id, (lineItems.get(variant.id) || 0) + 1);
      });

      // The real add-to-cart line items above are always the actual
      // variant id/quantity pairs regardless of what's displayed here -
      // this only ever substitutes the DISPLAYED number. See this file's
      // doc comment: discountedTiers is null (not just a missing key)
      // whenever this market/product isn't covered, so this intentionally
      // falls back to the plain sum in exactly the same cases it always
      // has, rather than ever showing a blank/broken price.
      const quantity = Number(card.dataset.quantity) || 1;
      const discountedCents = this.discountedTiers ? this.discountedTiers[String(quantity)] : undefined;
      // The REAL total for this selection - always the full bundle price,
      // never divided - is what bundle:change broadcasts (the sticky buy
      // bar shows what you're actually about to pay, not a per-unit
      // figure). settings.show_price_per_unit only ever changes what
      // THIS card's own text shows, computed separately below.
      const fullPriceCents = typeof discountedCents === 'number' ? discountedCents : totalPriceCents;
      const cardDisplayPriceCents =
        card.dataset.pricePerUnit === 'true' && quantity > 0 ? Math.round(fullPriceCents / quantity) : fullPriceCents;

      const priceEl = card.querySelector('[data-bundle-card-price]');
      if (priceEl) priceEl.textContent = formatMoney(cardDisplayPriceCents);

      document.dispatchEvent(
        new CustomEvent('bundle:change', {
          detail: {
            items: Array.from(lineItems.entries()).map(([id, quantity]) => ({ id, quantity })),
            totalPriceCents: fullPriceCents,
            available,
          },
        })
      );
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown_timer"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.labelEl = this.querySelector('[data-countdown-label]');
      this.clockEl = this.querySelector('[data-countdown-clock]');
      this.expiredEl = this.querySelector('[data-countdown-expired]');

      this.endTime =
        this.dataset.mode === 'duration' ? this.resolveDurationEndTime() : this.resolveEndDateEndTime();

      if (!this.endTime || isNaN(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    // Anchored to a real UTC moment (the "Z" suffix) so every customer
    // sees the same countdown target regardless of their own timezone.
    resolveEndDateEndTime() {
      const date = this.dataset.endDate;
      const time = this.dataset.endTime || '23:59';
      if (!date) return null;
      const target = new Date(`${date}T${time}:00Z`);
      return isNaN(target.getTime()) ? null : target.getTime();
    }

    // Per-visitor countdown: N hours from when this browser first saw it.
    // Persisted in localStorage per block instance so reloading the page
    // continues the same countdown instead of restarting it.
    resolveDurationEndTime() {
      const hours = Number(this.dataset.durationHours) || 24;
      const storageKey = `countdown-timer-start:${this.dataset.blockId}`;
      let startTime = Number(window.localStorage.getItem(storageKey));

      if (!startTime) {
        startTime = Date.now();
        try {
          window.localStorage.setItem(storageKey, String(startTime));
        } catch (error) {
          // Storage unavailable (private browsing, quota, etc.) - the
          // countdown still works for this page view, just won't persist
          // across reloads.
        }
      }

      return startTime + hours * 60 * 60 * 1000;
    }

    tick() {
      const remainingMs = this.endTime - Date.now();

      if (remainingMs <= 0) {
        window.clearInterval(this.interval);
        this.showExpired();
        return;
      }

      const totalSeconds = Math.floor(remainingMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const showTotalHours = this.dataset.showTotalHours === 'true';
      const hours = Math.floor((showTotalHours ? totalSeconds : totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = (value) => String(value).padStart(2, '0');
      // Only shown once there's at least a full day left - for anything
      // shorter, a leading "0 days" would just be clutter.
      const daysPrefix = !showTotalHours && days > 0 ? `${days} day${days === 1 ? '' : 's'} ` : '';

      if (this.clockEl) {
        this.clockEl.textContent = `${daysPrefix}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }
    }

    showExpired() {
      const hasExpiredText = this.expiredEl && this.expiredEl.textContent.trim() !== '';

      if (!hasExpiredText) {
        this.hidden = true;
        return;
      }

      if (this.labelEl) this.labelEl.hidden = true;
      if (this.clockEl) this.clockEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["media_gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.thumbsEl = this.querySelector('[data-gallery-thumbs]');
      this.thumbsIndicator = this.querySelector('[data-gallery-thumbs-indicator]');
      this.prevButton = this.querySelector('[data-gallery-prev]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.thumbsPrevButton = this.querySelector('[data-gallery-thumbs-prev]');
      this.thumbsNextButton = this.querySelector('[data-gallery-thumbs-next]');

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index)));
      });

      // Arrows route through the same goTo() -> IntersectionObserver ->
      // setActive() path as thumbnail/dot clicks, so the main image and
      // the thumbnail active-state indicator stay in sync automatically -
      // no separate state to keep updated here. Wraps around at both ends.
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          const next = (this.getCurrentIndex() - 1 + this.slides.length) % this.slides.length;
          this.goTo(next);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          const next = (this.getCurrentIndex() + 1) % this.slides.length;
          this.goTo(next);
        });
      }

      // Pages the thumbnail strip itself, separate from the main-image
      // arrows above - a "page" is 80% of the visible strip width, so
      // there's a little overlap with the previous page as a scroll
      // anchor, matching the common carousel-pagination convention.
      if (this.thumbsPrevButton && this.thumbsEl) {
        this.thumbsPrevButton.addEventListener('click', () => {
          this.thumbsEl.scrollBy({ left: -this.thumbsEl.clientWidth * 0.8, behavior: 'smooth' });
        });
      }

      if (this.thumbsNextButton && this.thumbsEl) {
        this.thumbsNextButton.addEventListener('click', () => {
          this.thumbsEl.scrollBy({ left: this.thumbsEl.clientWidth * 0.8, behavior: 'smooth' });
        });
      }

      if ('IntersectionObserver' in window && this.slides.length) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      if (this.thumbsEl && this.thumbsIndicator) {
        let ticking = false;
        const update = () => {
          const { scrollWidth, clientWidth, scrollLeft } = this.thumbsEl;

          if (scrollWidth <= clientWidth) {
            this.thumbsIndicator.style.width = '100%';
            this.thumbsIndicator.style.left = '0%';
            return;
          }

          const widthRatio = clientWidth / scrollWidth;
          const maxScroll = scrollWidth - clientWidth;
          const leftRatio = (scrollLeft / maxScroll) * (1 - widthRatio);

          this.thumbsIndicator.style.width = `${widthRatio * 100}%`;
          this.thumbsIndicator.style.left = `${leftRatio * 100}%`;
        };

        this.thumbsEl.addEventListener(
          'scroll',
          () => {
            if (!ticking) {
              requestAnimationFrame(() => {
                update();
                ticking = false;
              });
              ticking = true;
            }
          },
          { passive: true }
        );

        update();
      }

      this.setActive(0);
    }

    goTo(index) {
      const slide = this.slides[index];
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    // Only one of dots/thumbs is ever populated at once (indicator_style
    // is a single either/or choice), so whichever array has an
    // `.is-active` entry is the real current index.
    getCurrentIndex() {
      const activeDot = this.dots.find((dot) => dot.classList.contains('is-active'));
      if (activeDot) return Number(activeDot.dataset.index);

      const activeThumb = this.thumbs.find((thumb) => thumb.classList.contains('is-active'));
      if (activeThumb) return Number(activeThumb.dataset.index);

      return 0;
    }

    setActive(index) {
      this.dots.forEach((dot) => dot.classList.toggle('is-active', Number(dot.dataset.index) === index));
      this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', Number(thumb.dataset.index) === index));

      // setActive is only ever called in response to the main image
      // changing (swipe -> IntersectionObserver, or a thumbnail click ->
      // goTo -> IntersectionObserver) - never from scrolling the thumb
      // strip itself - so it's always correct to center here.
      const activeThumb = this.thumbs[index];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }

  class PinchZoom extends HTMLElement {
    constructor() {
      super();
      this.scale = 1;
      this.pointers = new Map();
      this.startDistance = 0;
      this.startScale = 1;
    }

    connectedCallback() {
      this.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.addEventListener('pointermove', this.onPointerMove.bind(this));
      this.addEventListener('pointerup', this.onPointerUp.bind(this));
      this.addEventListener('pointercancel', this.onPointerUp.bind(this));
    }

    onPointerDown(event) {
      this.pointers.set(event.pointerId, event);

      // Only take over the gesture once a second finger joins. A single
      // finger must keep triggering the browser's native horizontal swipe
      // on the gallery track - capturing it here would break that.
      if (this.pointers.size === 2) {
        this.pointers.forEach((_, id) => this.setPointerCapture(id));
        this.startDistance = this.getDistance();
        this.startScale = this.scale;
      }
    }

    onPointerMove(event) {
      if (!this.pointers.has(event.pointerId)) return;
      this.pointers.set(event.pointerId, event);

      if (this.pointers.size === 2 && this.startDistance) {
        const distance = this.getDistance();
        const nextScale = (distance / this.startDistance) * this.startScale;
        this.scale = Math.min(2, Math.max(1, nextScale));
        this.style.setProperty('--pinch-zoom-scale', this.scale);
      }
    }

    onPointerUp(event) {
      this.pointers.delete(event.pointerId);

      if (this.pointers.size < 2) {
        this.startDistance = 0;
      }

      if (this.pointers.size === 0 && this.scale <= 1) {
        this.scale = 1;
        this.style.setProperty('--pinch-zoom-scale', 1);
        this.style.setProperty('--pinch-zoom-x', '0px');
        this.style.setProperty('--pinch-zoom-y', '0px');
      }
    }

    getDistance() {
      const [a, b] = Array.from(this.pointers.values());
      return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  if (!customElements.get('pinch-zoom')) {
    customElements.define('pinch-zoom', PinchZoom);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    // Overwrites the first-paint (base-currency) placeholder with a
  // market-aware amount - see this file's doc comment. Matches
  // snippets/cart-contents.liquid's formatMoney() exactly. Runs once on
  // load - no fetch/reactivity needed, the cents value is already inline
  // via the data attribute.
  (function () {
    function formatMoney(cents) {
      return (Number(cents) / 100 || 0).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        // 'narrowSymbol' (not the default 'symbol') gives plain "$" instead
        // of a region-disambiguated prefix like "MX$" for MXN - see
        // snippets/cart-contents.liquid's formatMoney() for the same fix.
        currencyDisplay: 'narrowSymbol',
      });
    }

    document.querySelectorAll('[data-qty1-price-cents]').forEach((el) => {
      const cents = Number(el.dataset.qty1PriceCents);
      if (!Number.isNaN(cents)) el.textContent = formatMoney(cents);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonial_carousel"] && !Shopify.designMode) return;
  try {
    class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.dotsContainer = this.querySelector('[data-carousel-dots]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      // Same goTo() -> IntersectionObserver -> setActive() path as dot
      // clicks, so the dots stay in sync automatically. Wraps at both
      // ends, matching blocks/media_gallery.liquid's main-image arrows.
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          const next = (this.getCurrentIndex() - 1 + this.slides.length) % this.slides.length;
          this.goTo(next);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          const next = (this.getCurrentIndex() + 1) % this.slides.length;
          this.goTo(next);
        });
      }

      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonial-carousel__dot';
        dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
        return dot;
      });

      if ('IntersectionObserver' in window && this.slides.length) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      this.setActive(0);
    }

    goTo(index) {
      const slide = this.slides[index];
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    setActive(index) {
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    getCurrentIndex() {
      const activeIndex = this.dots.findIndex((dot) => dot.classList.contains('is-active'));
      return activeIndex === -1 ? 0 : activeIndex;
    }
  }

  if (!customElements.get('testimonial-carousel')) {
    customElements.define('testimonial-carousel', TestimonialCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant_picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    async connectedCallback() {
      this.selects = Array.from(this.querySelectorAll('[data-option-index]')).sort(
        (a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)
      );

      try {
        const response = await fetch(`/products/${this.dataset.productHandle}.js`);
        const product = await response.json();
        this.variants = product.variants.map((variant) => ({
          id: variant.id,
          price_cents: variant.price,
          available: variant.available,
          options: [variant.option1, variant.option2, variant.option3].filter(
            (value) => value !== null && value !== undefined
          ),
        }));
      } catch (error) {
        console.error('variant-picker: failed to load variant data', error);
        return;
      }

      this.selects.forEach((select) => {
        select.addEventListener('change', () => this.updateVariant());
      });

      this.updateVariant();
    }

    updateVariant() {
      const selectedValues = this.selects.map((select) => select.value);
      const variant = this.variants.find(
        (candidate) => candidate.options.length === selectedValues.length &&
          candidate.options.every((value, index) => value === selectedValues[index])
      );

      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            variantId: variant ? variant.id : null,
            available: variant ? variant.available : false,
            priceCents: variant ? variant.price_cents : null,
          },
        })
      );
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
